// extracted by mini-css-extract-plugin
export var aircallIframe = "_ix-3";
export var fabContainer = "_ix-5";
export var fabRinging = "_ix-6";
export var loadingOverlay = "_ix-4";
export var pulse = "_ix-7";
export var widgetContent = "_ix-2";
export var widgetPanel = "_ix-0";
export var widgetPanelExpanded = "_ix-1";